import React from "react";
import { Svg, Path } from "../componet/Footer/style";
import { useScroll } from "../context/UseContextScroll";

function Icon() {
  const { scroll } = useScroll();

  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      fill="none"
      viewBox="0 0 20 24"
      scroll={scroll}
    >
      <Path
        stroke="#D6004D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1118 0z"
      ></Path>
      <Path
        stroke="#D6004D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10 13a3 3 0 100-6 3 3 0 000 6z"
      ></Path>
    </Svg>
  );
}

export default Icon;
